import printReportAction from '@/components/nsw-components/PrintReportsAction';
import DocumentNewVersionAction from '@/components/nsw-components/DocumentNewVersionAction';

export default {
	actions: [printReportAction.printReport('ISPS', 'securityformid', 'reports.label.isps'), DocumentNewVersionAction.newVersion(null)]
};
